import { Link } from "react-router-dom";
import { BRAND } from "@/config/brand";

interface SystemPageProps {
  code: string;
  title: string;
  description: string;
  icon: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
  tone?: "default" | "maintenance";
}

export default function SystemPage({
  code,
  title,
  description,
  icon,
  primaryLabel = "Retour à l'accueil",
  primaryTo = "/",
  secondaryLabel,
  secondaryTo,
  tone = "default",
}: SystemPageProps) {
  return (
    <div className="flex min-h-[80vh] w-full items-center justify-center bg-background-50 px-4 py-16">
      <div className="animate-fade-up mx-auto w-full max-w-lg text-center">
        <span
          className={`mx-auto flex h-20 w-20 items-center justify-center rounded-2xl ${
            tone === "maintenance" ? "bg-accent-100 text-accent-800" : "bg-primary-100 text-primary-700"
          }`}
        >
          <i className={`${icon} text-4xl`} aria-hidden="true" />
        </span>
        <p className="mt-6 font-heading text-5xl font-semibold text-foreground-950">{code}</p>
        <h1 className="mt-3 text-2xl font-heading font-semibold text-foreground-950">{title}</h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to={primaryTo}
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-medium text-background-50 hover:bg-primary-600 hover:-translate-y-0.5 transition-all cursor-pointer sm:w-auto"
          >
            {primaryLabel}
          </Link>
          {secondaryLabel && secondaryTo && (
            <Link
              to={secondaryTo}
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-5 py-2.5 text-sm font-label font-medium text-foreground-900 hover:bg-background-100 hover:-translate-y-0.5 transition-all cursor-pointer sm:w-auto"
            >
              {secondaryLabel}
            </Link>
          )}
        </div>
        <p className="mt-10 text-xs text-foreground-400">
          {BRAND.name} · {BRAND.country}
        </p>
      </div>
    </div>
  );
}